function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: #f4f4f4;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: #f4f4f4;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 60px 20px;\n  flex: 1;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-weight: 100;\n  margin: 0 0 50px 0;\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
export var CampaignResult = styled.div(_templateObject());
export var Layout = styled.div(_templateObject1());
export var Body = styled.div(_templateObject2());
export var Heading = styled.h1(_templateObject3());
